module.exports = __webpack_public_path__ + "media/application/images/logo-green-023fe25d3d156bb2203b01e6785f068a.svg";